//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect } from 'react';
import styles from './styles.module.scss';

const PrivacyPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.container}>
      <div>
        <p className={styles.footnote}>Effective date: March 9, 2026</p>
        <h1>Privacy Policy</h1>
      </div>

      <div>
        <p>
          This Privacy Policy explains how POFKARIO HOLDINGS LIMITED, a Cyprus
          company with registration no. ΗΕ 467843 and registered address
          Thessalonikis 43, office/flat 301 Thessaloniki Court, 3025 Limassol,
          Cyprus (referred to as "Voery", "Company", "us", or "we") collects,
          stores, uses, and protects your personal data in connection with your
          use of our mobile application "Voery" (the "App"), our website (
          <a href='https://voery.app/' className={styles.grayText}>
            voery.app
          </a>
          ), and all related services (collectively the "Services").
        </p>
      </div>

      <div>
        <b>1. WHAT PERSONAL DATA WE COLLECT AND WHY</b>
        <p>
          We collect only the data necessary to provide real-time AI translation
          services.
        </p>

        <div className={styles.tableWrapper}>
          <table>
            {[
              [
                'Purpose',
                'Data Categories',
                'Legal Basis',
              ],
              [
                'Real-time Voice & Call Translation',
                'Audio recordings (temporary), voice-to-text transcripts, call metadata.',
                'Explicit Consent / Contract',
              ],
              [
                'AI Translation Processing',
                'Text data and audio segments shared with AI providers.',
                'Contract',
              ],
              [
                'Account Management',
                'Email address, name, unique user ID, device data.',
                'Contract',
              ],
              [
                'Premium Features & Payments',
                'Subscription status, transaction ID (handled via App Store/Google Play).',
                'Legal Obligation',
              ],
              [
                'Service Improvement',
                'Anonymized usage patterns, crash logs, performance data.',
                'Legitimate Interest',
              ],
            ].map((row, rowIdx) => {
              return (
                <tr key={rowIdx}>
                  {row.map((col, colIdx) => {
                    return rowIdx ? (
                      <td key={`${rowIdx}${colIdx}`}>{col}</td>
                    ) : (
                      <th key={`${rowIdx}${colIdx}`}>{col}</th>
                    );
                  })}
                </tr>
              );
            })}
          </table>
        </div>

        <p>
          <b>Note on Audio Data:</b> Voery processes your audio data solely for
          the purpose of real-time translation. Audio segments are transmitted
          via encrypted channels to our AI processing partners and are typically
          deleted immediately after the translation is generated.
        </p>
      </div>

      <div>
        <b>2. SHARING DATA WITH THIRD-PARTY AI SERVICES</b>
        <p>
          To provide our core translation features, we share data with trusted
          third-party AI service providers (<b>Palabra</b>).
        </p>
        <ul>
          <li>
            <b>Purpose:</b> Data is shared strictly for processing translations.
          </li>
          <li>
            <b>Protection:</b> Our partners act as Data Processors and are
            contractually obligated to provide the same level of data protection
            as Voery.
          </li>
          <li>
            <b>Training:</b> We ensure that our third-party AI providers do not
            use your personal data or voice recordings to train their AI models.
          </li>
        </ul>
      </div>

      <div>
        <b>3. DATA RETENTION</b>
        <p>
          We retain your personal data for as long as your account is active.
          Transcripts of translations may be stored locally on your device or on
          our secure servers if you choose to save your history. You may delete
          your account and all associated data at any time through the App
          settings or by contacting us at{' '}
          <a href='mailto:support@voery.app'>support@voery.app</a>.
        </p>
      </div>

      <div>
        <b>4. YOUR DATA PROTECTION RIGHTS (GDPR/UK GDPR)</b>
        <p>
          If you are a resident of the EEA or UK, you have the following rights:
        </p>
        <ul>
          <li>
            <b>Access and Portability:</b> Request a copy of your data.
          </li>
          <li>
            <b>Correction and Deletion:</b> Update or erase your personal
            information.
          </li>
          <li>
            <b>Withdrawal of Consent:</b> You may withdraw your consent for
            audio processing at any time by disabling microphone access in your
            device settings or stopping the use of translation features.
          </li>
        </ul>
      </div>

      <div>
        <b>5. SECURITY MEASURES</b>
        <p>
          We implement industry-standard security measures, including:
        </p>
        <ul>
          <li>
            <b>End-to-End Encryption (TLS 1.2+)</b> for all data in transit.
          </li>
          <li>
            <b>Access Control:</b> Strict internal policies to prevent
            unauthorized data access.
          </li>
          <li>
            <b>Vulnerability Scanning:</b> Regular system checks to ensure data
            safety.
          </li>
        </ul>
      </div>

      <div>
        <b>6. CHILDREN'S PRIVACY</b>
        <p>
          Our Services are not directed to individuals under 18 years of age. We
          do not knowingly collect data from children.
        </p>
      </div>

      <div>
        <b>7. CONTACT US</b>
        <p>
          If you have questions about this Privacy Policy, please contact us:
        </p>
        <ul>
          <li>
            Email:{' '}
            <a href='mailto:support@voery.app'>support@voery.app</a>
          </li>
          <li>
            Address: Thessalonikis 43, office/flat 301 Thessaloniki Court, 3025
            Limassol, Cyprus
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicy;